export default {
  navigationSectionIds: {
    main: 'MAIN_NAVIGATION',
    footer_about: 'FOOTER_ABOUT',
    footer_more: 'FOOTER_MORE',
    footer_help: 'FOOTER_HELP',
    footer_social_icons: 'FOOTER_SOCIAL_ICONS',
    footer_cc_icons: 'FOOTER_CC_ICONS',
    footer_menu: 'FOOTER_MENU',
    footer_partners: 'PARTNERS'
  }
}



// WEBPACK FOOTER //
// ./src/config/navigation.js